export default __webpack_public_path__ + "static/media/artmedica1.9d072c73.png";